
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import DashboardMachineHoursMachines from './DashboardMachineHoursMachines'

const Component = compose(

  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {

      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Home', url: '/' },
          { page: 'Dashboard', url: '/' },
          { page: 'Horas Máquina', url: '#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true

    },
    renderComponent(DashboardMachineHoursMachines),
    renderNothing
  )
)(DashboardMachineHoursMachines)

export default Component